import { Heading } from '../Heading';
import { EventCard } from './EventCard';

export const RelatedEvents = ({
  title,
  events,
}: {
  title?: string;
  events?: any[];
}) => {
  return (
    <div className="w-full max-w-6xl px-4 mx-auto">
      <Heading as="h4" variant="h4">
        {title || 'Join other live events'}
      </Heading>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-y-16 md:gap-y-0 md:gap-x-16">
        {events?.map((event) => (
          <EventCard
            key={event?.content?._uid}
            event={event}
            video={!!event?.content?.video?.url}
          />
        ))}
      </div>
    </div>
  );
};
